export const replaceValuesInString = (text: string, values = {}) => {
  return Object.entries(values).reduce((acc, [key, value]) => {
    return acc.replace(`{${key}}`, `${value}`);
  }, text);
};